
import React from "react";
import { Helmet } from "react-helmet-async";
import AgentUploadForm from "@/components/agent-upload-form";
import { useAuth } from "@/contexts/auth-context";
import { Navigate } from "react-router-dom";

const CreateAgent: React.FC = () => {
  const { user } = useAuth();

  // If user is not logged in or not a creator, redirect
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.profileType !== "creator") {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <Helmet>
        <title>Create an Agent - OGMAI</title>
      </Helmet>
      <div className="container max-w-4xl py-12">
        <AgentUploadForm />
      </div>
    </>
  );
};

export default CreateAgent;
